import httpClient from "../../api/httpClient";
import { createWrappedAsyncThunk } from "../createWrappedAsyncThunk";

export const getChats = createWrappedAsyncThunk("chats/getChats", async () => {
  const { data } = await httpClient.get(`customer/conversations`, {
    params: {
      limit: 50,
      offset: 0,
    },
  });
  return { data };
});

export const createConversation = createWrappedAsyncThunk(
  "chats/createConversation",
  async (payload) => {
    return await httpClient.post(`conversations`, payload);
  },
);

export const updateFileKey = createWrappedAsyncThunk(
  "chats/updateFileKey",
  async ({ attachment_id }) => {
    return await httpClient.post(`update-file-key`, {
      attachment_id,
    });
  },
);

export const getChatsById = createWrappedAsyncThunk(
  "chats/getChatsById",
  async ({ tenant_id, conversation_id }) => {
    const { data } = await httpClient.get(`customer/conversations`, {
      params: {
        conversation_id,
      },
    });
    return { tenant_id, data };
  },
);

export const fetchMessagesByConversationId = createWrappedAsyncThunk(
  "chats/fetchMessagesByConversationId",
  async ({ conversation_id, limit, offset }) => {
    const { data } = await httpClient.get(`messages`, {
      params: {
        conversation_id,
        limit,
        offset,
      },
    });
    return { data };
  },
);

export const fetchNotesByConversationId = createWrappedAsyncThunk(
  "chats/fetchNotesByConversationId",
  async ({ conversation_id }) => {
    const { data } = await httpClient.get(`conversation-notes`, {
      params: {
        conversation_id,
      },
    });
    return { data };
  },
);

export const fetchRemindersByConversationId = createWrappedAsyncThunk(
  "chats/fetchRemindersByConversationId",
  async ({ conversation_id }) => {
    const { data } = await httpClient.get(`reminders`, {
      params: {
        conversation_id,
      },
    });
    return { data: data };
  },
);

export const fetchChecklistByConversationId = createWrappedAsyncThunk(
  "chats/fetchChecklistByConversationId",
  async ({ conversation_id }) => {
    const { data } = await httpClient.get(`checklists`, {
      params: {
        conversation_id,
      },
    });
    return { data };
  },
);

export const addUpdateCheckpoint = createWrappedAsyncThunk(
  "chats/addUpdateCheckpoint",
  async (payload) => {
    return await httpClient.post(`checklist`, payload);
  },
);

export const updateConversation = createWrappedAsyncThunk(
  "chats/updateConversation",
  async ({ payload }) => {
    return await httpClient.post(`conversation/members`, payload);
  },
);
